import {ReactElement, ReactNode} from "react";
import {styled} from "styled-components";

import {breakpoints, quicksandSemiBold} from "@/GlobalStyle";

const TitleContent = styled.div`
  display: flex;
  flex-wrap: nowrap;
  border-bottom: solid 3px ${({theme}) => theme.colors.darkPrimary};
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  @media (max-width: ${breakpoints.md}) {
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
  }
`;

const TitleText = styled.h3`
  margin: 0;
  ${quicksandSemiBold}
  font-size: 1.25rem;
  color: ${({theme}) => theme.colors.mediumPrimary};
  flex: 1;
  @media (max-width: ${breakpoints.md}) {
    text-align: center;
  }
`;

export function Title({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}): ReactElement {
  return (
    <TitleContent>
      <TitleText>{title}</TitleText>
      {children}
    </TitleContent>
  );
}

const SmallTitleContent = styled.div`
  display: flex;
  flex-wrap: nowrap;
  border-bottom: solid 2px ${({theme}) => theme.colors.darkPrimary};
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  @media (max-width: ${breakpoints.md}) {
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
  }
`;

const SmallTitleText = styled.h3`
  margin: 0;
  ${quicksandSemiBold}
  font-size: 1rem;
  color: ${({theme}) => theme.colors.mediumPrimary};
  flex: 1;
  @media (max-width: ${breakpoints.md}) {
    text-align: center;
  }
`;

export function SmallTitle({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}): ReactElement {
  return (
    <SmallTitleContent>
      <SmallTitleText>{title}</SmallTitleText>
      {children}
    </SmallTitleContent>
  );
}
